import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['count', 'checkbox', 'submitButton', 'form'];

  connect() {
    this.boundPrepareSubmission = this.prepareSubmission.bind(this);
    this.recount();
    if (this.hasFormTarget) {
      this.formTarget.addEventListener('submit', this.boundPrepareSubmission);
    }
  }

  disconnect() {
    if (this.hasFormTarget) {
      this.formTarget.removeEventListener('submit', this.boundPrepareSubmission);
    }
  }

  recount() {
    if (!this.hasCountTarget) return;

    const selected = this.selectedCheckboxes;
    this.countTarget.textContent = `${selected.length} of ${this.visibleSelectableCount} selected`;
    this.toggleSubmitButton(selected.length > 0);
    this.updateSubmitLabel(selected);
  }

  updateSubmitLabel(selected) {
    if (!this.hasSubmitButtonTarget) return;

    const labelElement = this.submitButtonTarget.querySelector("span");
    if (!labelElement) return;
    if (!this.defaultSubmitLabel) this.defaultSubmitLabel = labelElement.textContent.trim();

    const nextVersions = selected.map((checkbox) => parseInt(checkbox.dataset.nextVersion, 10));
    if (selected.length > 0 && nextVersions.every(Number.isFinite)) {
      labelElement.textContent = `Re-report as v${Math.max(...nextVersions)}`;
    } else {
      labelElement.textContent = this.defaultSubmitLabel;
    }
  }

  get visibleSelectableCount() {
    return this.checkboxTargets.filter((cb) => !cb.disabled && cb.offsetParent !== null).length;
  }

  toggleSubmitButton(enabled) {
    if (!this.hasSubmitButtonTarget) return;

    if (enabled) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove(
        '!bg-black-300',
        '!text-black-600',
        '!cursor-not-allowed',
      );
      this.submitButtonTarget.classList.add('!cursor-pointer');
    } else {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add(
        '!bg-black-300',
        '!text-black-600',
        '!cursor-not-allowed',
      );
      this.submitButtonTarget.classList.remove('!cursor-pointer');
    }
  }

  prepareSubmission(event) {
    const selected = this.selectedCheckboxes;
    if (selected.length === 0) {
      event.preventDefault();
      return;
    }

    selected.forEach((checkbox, index) => {
      const idField = document.createElement('input');
      idField.type = 'hidden';
      idField.name = `valuation[quotes_attributes][${index}][id]`;
      idField.value = checkbox.value;
      this.formTarget.appendChild(idField);

      const eventField = document.createElement('input');
      eventField.type = 'hidden';
      eventField.name = `valuation[quotes_attributes][${index}][event]`;
      eventField.value = 'report';
      this.formTarget.appendChild(eventField);
    });
  }

  get selectedCheckboxes() {
    return this.checkboxTargets.filter((cb) => cb.checked && !cb.disabled);
  }
}
